import { useMemo } from 'react'
import { useDataValue } from 'Simple/Data.js'

/** @type {import('Simple/types.js').useDataTransform} */
export default function useDataTransform(props, data) {
  let app_id = useDataValue({
    context: 'flow_shortcuts',
    path: 'appId',
    viewPath: props.viewPath,
  })

  let install_app_id = useDataValue({
    context: 'flow_shortcuts',
    path: 'installAppId',
    viewPath: props.viewPath,
  })

  return useMemo(() => {
    return {
      ...data,
      selected: {
        ...data.selected,
        apps_filter: install_app_id ? 'directory' : data.selected.apps_filter,
        install_app_id: install_app_id ?? data.selected.install_app_id,
        app_id: app_id ?? data.selected.app_id,
      },
    }
  }, [data, install_app_id, app_id])
}
